/* NAAMANE maat en pasvorm: venster met tabbladen en maatadvies. */
if (!customElements.get('naamane-size-fit')) {
  class NaamaneSizeFit extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this._init = true;
      try { this.chart = JSON.parse(this.querySelector('[data-chart]').textContent || '{}') || {}; } catch (e) { this.chart = {}; }
      this.querySelectorAll('[data-open]').forEach((b) => b.addEventListener('click', () => this.open(b.dataset.open)));
      this.dialog.querySelector('[data-close]').addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
      this.dialog.querySelectorAll('[data-tab]').forEach((t) => t.addEventListener('click', () => this.show(t.dataset.tab)));
      this.dialog.querySelectorAll('[data-tab-go]').forEach((t) => t.addEventListener('click', () => this.show(t.dataset.tabGo)));
      const form = this.dialog.querySelector('form');
      if (form) form.addEventListener('submit', (e) => { e.preventDefault(); this.advise(); });
    }
    open(tab) { this.show(tab); this.dialog.showModal(); document.documentElement.classList.add('nm-fit-open'); }
    close() { this.dialog.close(); document.documentElement.classList.remove('nm-fit-open'); }
    show(tab) {
      if (!this.dialog.querySelector('[data-panel="' + tab + '"]')) tab = 'fit';
      this.dialog.querySelectorAll('[data-tab]').forEach((t) => t.setAttribute('aria-selected', String(t.dataset.tab === tab)));
      this.dialog.querySelectorAll('[data-panel]').forEach((p) => { p.hidden = p.dataset.panel !== tab; });
    }
    advise() {
      const form = this.dialog.querySelector('form');
      const out = this.dialog.querySelector('.nm-fit__result');
      const metingen = this.chart.metingen || [];
      const input = {};
      metingen.forEach((m) => { const v = parseFloat(form.elements[m] && form.elements[m].value); if (v > 0) input[m] = v; });
      const pref = form.elements.pref.value;
      if (!Object.keys(input).length) { out.hidden = false; out.textContent = 'Vul minstens een maat in.'; return; }
      const tolerance = { geen: 0, licht: 2, veel: 4 }[this.dataset.stretch] ?? 1;
      const sizes = Object.keys(this.chart.maten || {});
      let pick = -1;
      for (let i = 0; i < sizes.length; i++) {
        const ok = Object.entries(input).every(([m, v]) => {
          const r = this.chart.maten[sizes[i]][m];
          const max = Array.isArray(r) ? r[1] : r;
          return max === undefined || v <= max + tolerance;
        });
        if (ok) { pick = i; break; }
      }
      if (pick === -1) { out.hidden = false; out.textContent = 'Je maten vallen buiten deze tabel. Stuur ons een bericht, dan denken we mee.'; return; }
      if (pref === 'los' && pick < sizes.length - 1) pick += 1;
      if (pref === 'strak' && pick > 0 && tolerance >= 2) {
        const prev = sizes[pick - 1];
        const fitsTight = Object.entries(input).every(([m, v]) => { const r = this.chart.maten[prev][m]; return !Array.isArray(r) || v <= r[1] + tolerance + 1; });
        if (fitsTight) pick -= 1;
      }
      const size = sizes[pick];
      out.hidden = false;
      out.innerHTML = '<p class="nm-fit__advice">Ons advies: <strong>maat ' + size + '</strong></p><button type="button" class="nm-fit__choose">Kies maat ' + size + '</button>';
      out.querySelector('.nm-fit__choose').addEventListener('click', () => { this.selectSize(size); this.close(); });
    }
    selectSize(size) {
      const scope = this.closest('.shopify-section') || document;
      const radios = [...scope.querySelectorAll('variant-picker input[type="radio"]')];
      const match = radios.find((el) => el.value === size);
      if (match) { match.click(); return; }
      const select = scope.querySelector('variant-picker select');
      if (select) { select.value = size; select.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  }
  customElements.define('naamane-size-fit', NaamaneSizeFit);
}